import { inboxAutosetMaps } from 'config/autoset-urgency-inbox';

// TODO: might have to update import urgencies to be from this file
export const urgencies = [
  'N-Normal', // first value will be counted as default
  'U-Urgent',
  'V-VIP',
];

export const frontendDefaultUrgency = urgencies[0];

const getDefaultUrgencyForInboxAddress = (inboxAddress: string) => {
  let env = process.env.REACT_APP_BUILDENV ?? 'dev';
  if (!(env in inboxAutosetMaps)) {
    env = 'dev';
  }
  const inboxAutosetMap = inboxAutosetMaps[env];
  const val = inboxAutosetMap[inboxAddress]?.urgency;
  console.debug(`getDefaultUrgencyForInboxAddress`, val);
  return val ?? frontendDefaultUrgency;
};

const Urgency = {
  getDefaultUrgencyForInboxAddress,
};

export default Urgency;
